"use client"

import { BlogCategory } from "@/api/generated/BMWInterfaces"
import colors from "@/lib/theme/colors"
import { Button, styled } from "@mui/material"

const StyledCategoryBar = styled("div")`
  display: flex;
  flex-direction: row;
  gap: 16px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
  ${(p) => p.theme.breakpoints.up("md")} {
    width: fit-content;
    margin: 0 auto;
  }
`

const StyledCategoryPill = styled(Button)<{ $active: boolean }>`
  height: 38px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1.5px solid
    ${({ $active }) => ($active ? colors.directBlack : colors.directVeryLightGray)};
  background-color: ${({ $active }) => ($active ? colors.directDisable : colors.white)};
  color: ${({ $active }) => ($active ? colors.directBlack : colors.black)};
  font-size: 18px;
  font-weight: ${({ $active }) => ($active ? 500 : 400)};
  transition:
    background-color 0.15s,
    border-color 0.15s,
    color 0.15s;
  white-space: nowrap;
  min-width: fit-content;

  @media (hover: hover) {
    &:hover {
      border-color: ${colors.directBlack};
    }
  }
`

interface BlogCategoriesProps {
  categories: BlogCategory[]
  activeCategoryId: number[]
  onCategoryChange: (id: number[]) => void
}

const BlogCategories = ({
  categories,
  activeCategoryId,
  onCategoryChange,
}: BlogCategoriesProps): React.ReactElement | null => {
  // DLK-669: hide the bar (incl. the "כל הכתבות" button) when no categories exist.
  if (!categories?.length) {
    return null
  }

  const isAllActive = !activeCategoryId || activeCategoryId.length === 0
  return (
    <StyledCategoryBar role="tablist" aria-label="סינון לפי קטגוריה">
      <StyledCategoryPill
        role="tab"
        aria-selected={isAllActive}
        $active={isAllActive}
        onClick={() => onCategoryChange([])}
      >
        כל הכתבות
      </StyledCategoryPill>
      {categories.map((cat) => (
        <StyledCategoryPill
          key={cat.id}
          role="tab"
          aria-selected={activeCategoryId?.includes(cat.id) || false}
          $active={activeCategoryId?.includes(cat.id) || false}
          onClick={() => {
            if (activeCategoryId?.includes(cat.id)) {
              onCategoryChange(activeCategoryId.filter((id) => id !== cat.id))
            } else {
              onCategoryChange(activeCategoryId ? [...activeCategoryId, cat.id] : [cat.id])
            }
          }}
        >
          {cat.name}
        </StyledCategoryPill>
      ))}
    </StyledCategoryBar>
  )
}

export default BlogCategories
